<button
	(click)="openProjectDialog()"
	*ngIf="
		!isEditProject &&
		!isDuplicateProject &&
		!addProjectLink &&
		!forScorecardAction &&
		!useMenuButton &&
		!noCaps
	"
	[ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"
	color="primary"
	mat-raised-button
>
	<span>NEW PROJECT</span>
</button>

<button
	(click)="openProjectDialog()"
	*ngIf="isEditProject && !isDuplicateProject && !addProjectLink"
	color="primary"
	mat-raised-button
>
	<mat-icon class="m-r-1">edit</mat-icon>
	Edit Project
</button>

<button
	(click)="$event.stopPropagation(); openProjectDialog()"
	*ngIf="isDuplicateProject && !isEditProject && !addProjectLink"
	mat-icon-button
	matTooltip="Duplicate Project"
	matTooltipClass="custom-tooltip"
>
	<mat-icon class="primary-light-color">file_copy</mat-icon>
</button>

<span (click)="openProjectDialog()" *ngIf="addProjectLink" class="link">Add New Project</span>

<button
	(click)="openProjectDialog()"
	*ngIf="forScorecardAction"
	[disabled]="disabled"
	[ngClass]="{ 'primary-text': !disabled }"
	mat-menu-item
>
	Build Project
</button>

<button (click)="openProjectDialog()" *ngIf="useMenuButton" class="{{ textClass }}" mat-menu-item>
	New Project
</button>
